import React from 'react';
import styles from './GGS.module.css';

const GGSMain = () => {

    return(
        <div className="wrapper wrapperContent">
            <div className={styles.text}>
                <h1>LEITBILD</h1>
                <h2>Demokratische Grundwerte</h2>
                <ul className={styles.listBlock}>
                    <li>Wir haben realistische Erwartungen an uns und alle Mitglieder unserer Schule!</li>
                    <li>Wir sind eine Schule mit demokratischer Kultur, in der alle freundlich und wertschätzend miteinander umgehen.</li>
                    <li>Wir erachten demokratische Grundwerte sowie das Mitbestimmungsrecht als bedeutsam.</li>
                    <li>Wir gehen mit Konflikten konstruktiv um und handeln gemäß unserem Präventionskonzept.</li>
                    <li>Wir akzeptieren keine Gewalt.</li>
                    <li>Wir achten auf höfliche Umgangsformen.</li>
                    <li>Wir reden miteinander statt übereinander und respektieren die Meinung anderer.</li>
                    <li>Wir hören einander zu.</li>
                </ul>

                <h2>Vielfalt ist unsere Stärke</h2>
                <ul className={styles.listBlock}>
                    <li>Wir stellen die Stärken unserer Schülerinnen und Schüler in den Vordergrund.</li>
                    <li>Wir arbeiten binnendifferenziert.</li>
                    <li>Wir setzen kooperative Lernformen ein.</li>
                    <li>Wir evaluieren unseren Unterricht im Team.</li>
                    <li>Wir fördern das selbstständige Lernen unserer Schülerinnen und Schüler.</li>
                </ul >

                <h2>Ganzheitliches Lernen</h2>
                <ul className={styles.listBlock}>
                    <li>Wir besuchen regelmäßig außerschulische Lernorte.</li>
                    <li>Wir ermöglichen Projektunterricht, auch jahrgangsübergreifend.</li>
                    <li>Wir greifen auf das Wissen von Menschen aus dem Umfeld zurück.</li>
                    <li>Wir fördern Patenschaften und Nachhilfesysteme.</li>
                </ul>
            </div>

            <div className={styles.text}>
                <h1>PROFIL</h1>
                <h2>Vorsprung von Anfang an</h2>
                <ul className={styles.listBlock}>
                    <li>Wir fördern die intensive Grundlagenbildung in Deutsch, Englisch, Mathematik, Musik und Sport, sowie die Entwicklung zur Mehrsprachigkeit durch zielgerichtete Angebote.</li>
                    <li>Englisch wird bereits ab der ersten Klasse angeboten, weil wir so unserem Bildungsprinzip der kulturellen und sprachlichen Vielfalt näher kommen.</li>
                </ul>

                <h2>Erweitertes Betreuungsangebot</h2>
                <ul className={styles.listBlock}>
                    <li>Sowohl Früh- als auch Spätbetreuung ist möglich</li>
                    <li>Selbstverständlich bieten wir auch Ferienbetreuung an</li>
                </ul>

                <h2>Unsere Schwerpunkte</h2>
                <ul className={styles.listBlock}>
                    <li>Unterricht in kleinen Klassen mit ganzheitlichem Unterrichtsansatz</li>
                    <li>Englisch ab dem 1. Schuljahr / Cambridge English</li>
                    <li>Umfangreiches Fremdsprachenangebot und Begegnungssprachen</li>
                    <li>Interkulturelle Bildung als durchgehendes Unterrichtsprinzip</li>
                    <li>Musikalische Früherziehung / Instrumentenvielfalt</li>
                    <li>Hausaufgabenbetreuung in Form von Lernwerkstätten</li>
                    <li>Individuelles Fördern und Fordern</li>
                    <li>Spannende Sportprojekte, z.B. Sport- und Schwimmunterricht ab der 1. Klasse</li>
                    <li>Kompetentes, aufgeschlossenes Kollegium</li>
                    <li>Intensive, partnerschaftliche Kooperation von Schüler/innen, Eltern und LehrerInnen</li>
                    <li>Interkulturelles Lernen durch die Erziehung zu Toleranz und Respekt gegenüber anderen Kulturen</li>
                    <li>Projektorientiertes und vernetztes Lernen</li>
                    <li>Förderangebote beim sprachlichen Unterstützungsbedarf</li>
                </ul>
            </div>

        </div>
    );
};

export default GGSMain;